import React from "react";
import QuantitativeIndicatorFields from "./QuantitativeIndicatorFields";
import QualitativeIndicatorFields from "./QualitativeIndicatorFields";
import QuantitativeDimensionalIndicatorFields from "./QuantitativeDimensionalIndicatorFields";

const IndicatorsFieldsFactory = ({ indicator, setIndicator, indicatorType, className = null }) => {
    return (
        <>
            {indicatorType === 'QUANTITATIVE' && (
                <QuantitativeIndicatorFields indicator={indicator} setIndicator={setIndicator} className={className} />
            )}
            {indicatorType === 'QUALITATIVE' && (
                <QualitativeIndicatorFields indicator={indicator} setIndicator={setIndicator} className={className} />
            )}
            {indicatorType === 'QUANTITATIVE_DIMENSIONAL' && (
                <QuantitativeDimensionalIndicatorFields indicator={indicator} setIndicator={setIndicator} className={className} />
            )}
        </>
    );
}

export default IndicatorsFieldsFactory;